import {useContext, useEffect, useRef, useState} from "react";
import axios from "axios";
import {
    CustomErrorToast,
    CustomLoadingToast,
    CustomSuccessToast, CustomToastContainer, updateCustomErrorToast,
    updateCustomSuccessToast
} from "../utilities/CustomToast";
import FlexBox from "../utilities/FlexBox";
import Loader from "../utilities/Loader";
import {InfoCircle, InfoCircleFill, X} from "react-bootstrap-icons";
import {Button} from "react-bootstrap";
import CompanyTeamContext from "../../CompanyTeamContext";
import {API_URL_PREFIX} from "../../utilities/Constants";
import checkEmail from "../../pages/user/login-register/Utilities";
import ModalBackground from "../utilities/modal/ModalBackground";
import ModalHeader from "../utilities/modal/ModalHeader";
import DOMPurify from "dompurify";
import companyTeamContext from "../../CompanyTeamContext";
import {isLiveTestOrQuiz} from "../../pages/test/tests-list/TestsList";
import Checkbox from "../utilities/Checkbox";
import ScheduleCheckbox from "./ScheduleCheckbox";
import './SendTest.css';

export const sendTestToCandidate = (selectedTest, candidate, setShow, refresh, setSentStatus, refreshQuota, setSubmitted = ()=>{}, scheduled = false, scheduledDate = null)=>{
    if(!selectedTest || selectedTest == "dis" || !candidate) {
        CustomErrorToast("Select Test");
        return;
    }
    if(scheduled && !scheduledDate){
        CustomErrorToast("Select valid scheduled date/time");
        return;

    }
    if((scheduled && new Date(scheduledDate) < new Date())){
        CustomErrorToast("Date/time must be in the future");
        return;
    }

    setSubmitted(true)
    const id = CustomLoadingToast("Sending...")
    let url = API_URL_PREFIX+"/SendQuizToCandidate.html?candId="+candidate.key+"&testId="+selectedTest;
    if(scheduled){
        // send scheduled date, its a ISO string, include the timezone
        url += "&scheduledDate="+encodeURIComponent(new Date(scheduledDate).toISOString());
    }
    axios.post(url)
        .then(e=>{
            if(e.data.result){
                if(scheduledDate){
                    updateCustomSuccessToast("The test will be sent to the candidate on the selected date. ", id);
                }
                else {
                    updateCustomSuccessToast("Test sent to candidate.",id);
                }

                //setSubmitted(false)
                if(setShow) setShow(false);
                if(refreshQuota) refreshQuota();
                if(refresh) refresh();
                if(setSentStatus){
                    setSentStatus(prev => {
                        if(!prev) return {[candidate.key]:true}
                        return {...prev, [candidate.key]:true}
                    })
                }
            }
            else{
                setSubmitted(false)
                if(e.data.info)
                    updateCustomErrorToast(e.data.info, id)
                else{
                    updateCustomErrorToast("Error adding test", id)
                }
            }
        })
        .catch(e=>{
            setSubmitted(false)
            updateCustomErrorToast("Error adding test", id);
        })
}

export const sendTestToNewCandidate = (selectedTest, candidate, setShow, refresh, setSentStatus, refreshQuota, scheduled, scheduledDate)=>{
    if(!selectedTest || selectedTest == "dis" || !candidate) {
        CustomErrorToast("Select Test");
        return;
    }

    if(!candidate.name) {
        CustomErrorToast("Fill candidate name");
        return;
    }

    if(!candidate.email || !checkEmail(candidate.email)) {
        CustomErrorToast("Invalid email");
        return;
    }

    if(scheduled && !scheduledDate){
        CustomErrorToast("Select valid scheduled date/time");
        return;

    }
    if((scheduled && new Date(scheduledDate) < new Date())){
        CustomErrorToast("Date/time must be in the future");
        return;
    }

    const id = CustomLoadingToast("Sending...")

    let url = API_URL_PREFIX+"/SendQuizToNewCandidate.html?candName="+candidate.name+"&candEmail="+candidate.email+"&testId="+selectedTest
    if(scheduled){
        // send scheduled date, its a ISO string, include the timezone
        url += "&scheduledDate="+encodeURIComponent(new Date(scheduledDate).toISOString());
    }
    axios.post(url)
        .then(e=>{
            if(e.data.result){
                if(scheduledDate){
                    updateCustomSuccessToast("The test will be sent to the candidate on the selected date. ", id);
                }
                else {
                    updateCustomSuccessToast("Test sent to candidate.",id);
                }
                if(setShow) setShow(false);
                if(refreshQuota) refreshQuota();
                if(refresh) refresh();
            }
            else{
                if(e.data.info)
                    updateCustomErrorToast(e.data.info, id)
                else{
                    updateCustomErrorToast("Error adding test", id)
                }
            }
        })
        .catch(e=>{
            updateCustomErrorToast("Error adding test", id);
        })
}

export const SendTestsCSV = ({setShow, refreshCandidates = ()=>{}}) => {
    const [tests, setTests] = useState([])
    const [loader, setLoader] = useState(true)
    const [selectedTest, setSelectedTest] = useState("dis")
    const [csvData, setCsvData] = useState()
    const [submitted, setSubmitted] = useState(false)
    const [fileName, setFileName] = useState("")
    const {refresh} = useContext(companyTeamContext)
    const ref = useRef()

    const [scheduled, setScheduled] = useState(false)
    const [scheduledDate, setScheduledDate] = useState(
        new Date(new Date().setDate(new Date().getDate() + 1) - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16)
    );

    useEffect(()=>{
        axios.get(API_URL_PREFIX+"/GetCompanyLiteTests.html")
            .then(response => {
                setLoader(false)
                if (response.data.err) {
                    CustomErrorToast("Permission Denied!")
                }
                else{


                    if(response.data){
                        let predefined = response.data.filter(e=>e.predefinedTest).sort((b,a) => {
                            return (b.name.toLowerCase().localeCompare(a.name.toLowerCase()));
                        })
                        let org = response.data.filter(e=>!(e.predefinedTest)).sort((b,a) => {
                            return (b.name.toLowerCase().localeCompare(a.name.toLowerCase()));
                        })
                        let tests = [...org, ...predefined]
                        setTests(tests);

                        if(tests.length > 0){
                            setSelectedTest(tests[0].key)
                        }
                    }


                }
            })
            .catch(e => {
                setLoader(false);
                if(e.response?.status == 403){
                    CustomErrorToast("Permission Denied!")
                }
                else{
                    CustomErrorToast("Error fetching tests, Please try again.")
                }
            })
    },[])

    const sendTestInvitations = (scheduled, scheduledDate) =>{
        const formData = new FormData();
        formData.append('file', csvData);
        if(!csvData){
            CustomErrorToast("No CSV were uploaded.")
        }
        if(!selectedTest){
            CustomErrorToast("No test was selected.")
        }

        if(scheduled && !scheduledDate){
            CustomErrorToast("Select valid scheduled date/time");
            return;

        }
        if((scheduled && new Date(scheduledDate) < new Date())){
            CustomErrorToast("Date/time must be in the future");
            return;
        }


        setSubmitted(true)
        const id = CustomLoadingToast("Processing...")
        let url = '/SendQuizzedCSV.html?testId='+encodeURIComponent(selectedTest)
        if(scheduled){
            // send scheduled date, its a ISO string, include the timezone
            url += "&scheduledDate="+encodeURIComponent(new Date(scheduledDate).toISOString());
        }
        axios.post(url, formData)
            .then(res=>{
                setSubmitted(false)
                let data = res.data
                console.log(data);
                if(typeof data == 'string'){
                    data = JSON.parse(data)
                }
                if(data.result === true){
                    if(scheduledDate){
                        updateCustomSuccessToast("The tests will be sent to the candidates on the selected date.", id);
                    }
                    else {
                        updateCustomSuccessToast(data.info+" tests were sent successfully!", id)
                    }

                    if(refresh){
                        refresh();
                    }
                    refreshCandidates();
                    setShow(false)
                }
                else{
                    if(data.err === true){
                        if(data.info){
                            updateCustomErrorToast(data.info,id)
                        }
                        else{
                            updateCustomErrorToast("Error! Please verify that the CSV file is valid and try again.",id)
                        }
                    }
                }
            })
            .catch(e=>{
                setSubmitted(false)
                updateCustomErrorToast("Error! Please verify that the CSV file is valid and try again.",id)
            })
    }

    return (
        <ModalBackground style={{position:"fixed"}}>
            <Loader loader={loader}/>
            <FlexBox direction={"column"} direction={"column"} justify={"start"} align={"start"}
                     style={{width: "650px", height:"maxContent", background: "white"}}>
                <ModalHeader title={"Send Tests - CSV"} setShow={setShow} />
                <FlexBox direction={"column"} justify={"start"} style={{padding:"15px", width:"100%"}}>


                    <div style={{display:"flex", justifyContent:"start", alignItems:"center", width:"100%"}}>
                        <div style={{width:"114px"}}>Select Test:&nbsp;</div>
                        {tests && tests.length > 0 ?
                            <select value={selectedTest} onChange={e=>setSelectedTest(e.target.value)} className={"form-select"}>
                                {tests.map(e=><option key={e.key+"SendTestsCSV"} value={e.key}>
                                    {(e.predefinedTest ?  e.name + " [Predefined]" : e.name) + (isLiveTestOrQuiz(e) ? " [Live]" : "")}
                                </option>)}
                            </select> : <p>No Tests Found</p>}
                    </div>
                    <br/>
                    <div style={{display:"flex", justifyContent:"center", alignItems:"center", width:"100%"}}>
                        <input hidden={true}
                            type="file"
                            ref={ref}
                            accept=".csv"
                            onChange={(e) => {
                                setCsvData(e.target.files[0]);
                                setFileName(e.target.files[0].name)
                                console.log(e.target.files[0])
                            }}
                        />
                        <div style={{textAlign:"center"}}>
                            <Button onClick={()=>(ref.current.click())}>Select CSV File</Button>

                            <small><br/>&nbsp;{fileName}</small>
                        </div>
                    </div>
                    <small style={{marginTop:"10px", textAlign:"center", width:"100%"}}>
                        Note: The CSV file should contain two mandatory columns, candidate name and email.<br/>
                        Records with invalid emails will be skipped.
                    </small>

                    <br/>
                    <ScheduleCheckbox
                        scheduled={scheduled}
                        setScheduled={setScheduled}
                        scheduledDate={scheduledDate}
                        setScheduledDate={setScheduledDate}
                        style={{display:"flex", justifyContent:"center"}}
                    />
                    <br/>
                    <Button onClick={()=>sendTestInvitations(scheduled, scheduledDate)} disabled={submitted || !csvData}>{scheduled ? "Schedule Test Invitations" : "Send Test Invitations"}</Button>
                </FlexBox>
            </FlexBox>
        </ModalBackground>
    )
}

const SendTest = ({candidate, setShow, refresh, submitted, setSubmitted})=>{
    const [tests, setTests] = useState([])
    const [loader, setLoader] = useState(true)
    const [selectedTest, setSelectedTest] = useState("dis")
    const company = useContext(CompanyTeamContext) || {}
    const [scheduled, setScheduled] = useState(false)
    const [scheduledDate, setScheduledDate] = useState(
        new Date(new Date().setDate(new Date().getDate() + 1) - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16)
    );
    let refreshQuota = company.refresh

    useEffect(()=>{
        axios.get(API_URL_PREFIX+"/GetCompanyLiteTests.html")
            .then(response => {
                setLoader(false)
                if (response.data.err) {
                    CustomErrorToast("Permission Denied!")
                }
                else{
                    if(response.data){
                        let predefined = response.data.filter(e=>e.predefinedTest).sort((b,a) => {
                            return (b.name.toLowerCase().localeCompare(a.name.toLowerCase()));
                        })
                        let org = response.data.filter(e=>!(e.predefinedTest)).sort((b,a) => {
                            return (b.name.toLowerCase().localeCompare(a.name.toLowerCase()));
                        })
                        let tests = [...org, ...predefined]
                        setTests(tests);

                        if(tests.length > 0){
                            setSelectedTest(tests[0].key)
                        }
                    }
                }
            })
            .catch(e => {
                setLoader(false);
                if(e.response?.status == 403){
                    CustomErrorToast("Permission Denied!")
                }
                else{
                    CustomErrorToast("Error fetching tests, Please try again.")
                }
            })
    },[])

    return (
        <FlexBox align={"start"} style={{width:"100vw", height:"100vh", position:"fixed", top:0, left:0, zIndex:"1000", background:"rgba(0,0,0,.25)"}}>
            <Loader loader={loader}/>
            <CustomToastContainer/>
            <div className={"hard-shadow send-test-modal-wrapper"}>
                <div className="send-test-modal-header" style={{textAlign:"left", width:"100%", height:"80px", background:"#4760F1", position:"relative"}}>
                    <FlexBox justify={"start"} align={"center"} style={{
                        lineHeight: "20px", color: "#fff", fontWeight: "800", fontSize: "20px", height:"100%", padding:"20px"
                    }}><span>Send Test to {candidate.firstName}</span>
                        <X size={"25px"} onClick={(e)=>setShow(false)} style={{position:"absolute", right:15, top:15, cursor:"pointer"}}></X>
                    </FlexBox>


                </div>
                <div className="send-test-modal-body" style={{padding:"20px"}}>
                    {tests && tests.length > 0 ?
                    <select id={"selectTestSelect"} value={selectedTest} onChange={e=>setSelectedTest(e.target.value)} className={"form-select"}>
                        {/*<option disabled={true} value={"dis"}>Select Test</option>*/}
                        {tests.map(e=><option value={e.key}>
                            {

                            }
                            { (e.predefinedTest ? e.name + " [Predefined]" : e.name) + (isLiveTestOrQuiz(e) ? " [Live]" : "")}
                        </option>)}
                    </select> : <p>No Tests Found</p>}

                    <ScheduleCheckbox
                        scheduled={scheduled}
                        setScheduled={setScheduled}
                        scheduledDate={scheduledDate}
                        setScheduledDate={setScheduledDate}
                            />
                    <br/>
                    <div className="send-test-buttons-wrapper">
                        <Button
                            className="send-test-cancel-button"
                            onClick={(e)=>setShow(false)}
                            variant={"outline-primary"}>Cancel</Button>
                        <Button id={"sendTestAction"}
                                onClick={e => sendTestToCandidate(selectedTest, candidate, setShow, refresh, null, refreshQuota, setSubmitted, scheduled, scheduledDate)}
                                variant={"primary"} disabled={submitted}>{scheduled ? "Schedule a Test" : "Send Test"}</Button>
                    </div>
                </div>


            </div>
        </FlexBox>
    )

}

export default SendTest